import SectionItem from '../../Layout/SectionItem/SectionItem'
import { LuxMultiSelect, LuxRichInputText } from '@lux/wardrobe-lib'
import { useIntl } from 'react-intl'
import SectionItemContainer from '../../Layout/SectionItemContainer/SectionItemContainer'
import { ProjectsService } from '@/app/services/ProjectsService'
import './EditingReason.scss'
import { canEdit } from '@Techedge/digitalportal-shared'

const reasonWhyOptions = [
    { value: 'titleDescription', label: 'modals.editing.reason.titleDescription' },
    { value: 'action', label: 'modals.editing.reason.action' },
    { value: 'distributionList', label: 'modals.editing.reason.distributionList' },
    { value: 'assignment', label: 'modals.editing.reason.assignment' },
    { value: 'scheduling', label: 'modals.editing.reason.scheduling' },
    { value: 'attachment', label: 'modals.editing.reason.attachment' },
]

const EditingReason = (props: any) => {
    const componentClass = 'smart-new-activity-editing-reason'
    const {
        projectType,
        reasonWhy,
        onReasonWhy,
        editingReason,
        onEditingReason,
        messageForStores,
        onMessage,
        disabled,
    } = props
    const intl = useIntl()

    return (
        <SectionItemContainer hideFooter={true}>
            <SectionItem>
                <div className={`${componentClass}__reason`}>
                    <LuxMultiSelect
                        value={reasonWhy}
                        disabled={disabled}
                        label={intl.formatMessage({
                            id: 'modals.new.activity.editing.reason.why',
                            defaultMessage: 'Reason Why',
                        })}
                        mandatory
                        onChangeCallback={(value) => onReasonWhy(value)}
                        options={reasonWhyOptions.map((reason) => ({
                            ...reason,
                            label: intl.formatMessage({
                                id: reason.label,
                                defaultMessage: reason.value,
                            }),
                        }))}
                        placeholder={intl.formatMessage({
                            id: 'modals.new.activity.editing.reason.why',
                            defaultMessage: 'Reason Why',
                        })}
                        additionalProps={{
                            appendTo: 'self',
                        }}
                    />
                </div>
            </SectionItem>
            <SectionItem>
                <LuxRichInputText
                    value={editingReason}
                    mandatory={true}
                    onChangeCallback={(value) => onEditingReason(value)}
                    placeholder={intl.formatMessage({
                        id: 'modals.new.activity.editing.reason.placeholder',
                        defaultMessage: 'Type here..',
                    })}
                    label={intl.formatMessage({
                        id: 'modals.new.activity.editing.reason.text',
                        defaultMessage: 'Editing Reason',
                    })}
                    fileUploadUrl={ProjectsService.FROALA_UPLOAD_URL}
                    config={{
                        events: {
                            initialized() {
                                const editor = this
                                if (disabled) editor.edit.off()
                            },
                        },
                    }}
                />
            </SectionItem>
            {canEdit(projectType) && (
                <SectionItem>
                    <LuxRichInputText
                        value={messageForStores}
                        onChangeCallback={(value) => onMessage(value)}
                        placeholder={intl.formatMessage({
                            id: 'modals.new.activity.editing.reason.placeholder',
                            defaultMessage: 'Type here..',
                        })}
                        label={intl.formatMessage({
                            id: 'modals.new.activity.editing.reason.message.for.stores',
                            defaultMessage: 'Message for stores',
                        })}
                        fileUploadUrl={ProjectsService.FROALA_UPLOAD_URL}
                        config={{
                            events: {
                                initialized() {
                                    const editor = this
                                    if (disabled) editor.edit.off()
                                },
                            },
                        }}
                    />
                </SectionItem>
            )}
        </SectionItemContainer>
    )
}

export default EditingReason
